module.exports = __webpack_public_path__ + "img/qrcodeb.9b92faae.png";